import { faBuilding, faCubes, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Flex, Line } from 'components';
import { H1, H2 } from 'components/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { SettingTab } from 'views/AdministrationView/components/SettingTab/SettingTab';
import { Wrapper } from 'views/AdministrationView/AdministrationView.styled';

export const PlatformView = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <H1 variant="h1">{t('platform.title')}</H1>
      <Line />
      <H2 mt={3} variant="h2" color="coloured">
        {t('platform.management')}
      </H2>
      <Line />
      <Flex flexWrap="wrap">
        <SettingTab
          title="platform.companies.title"
          description="platform.companies.description"
          icon={faBuilding}
          link="companies"
        />
        <SettingTab
          title="platform.users.title"
          description="platform.users.description"
          icon={faUsers}
          link="users"
        />
        <SettingTab
          title="platform.resources.title"
          description="platform.resources.description"
          icon={faCubes}
          link="resources"
        />
      </Flex>
    </Wrapper>
  );
};
